import React from "react";

import { Icon, PlainButton } from "@culturehq/components";

import { Trans } from "app/utils";

interface SubtitleTitleProps {
  onBackAction: () => void;
  showLanguageOptions: boolean;
  showStyles: boolean;
}

const SubtitleTitle: React.FC<SubtitleTitleProps> = ({
  onBackAction, showLanguageOptions, showStyles
}) => (
  <div className="Subtitles-Header__Title">
    {(showStyles || showLanguageOptions) && (
      <PlainButton onClick={onBackAction}>
        <Icon icon="chevron-left" />
      </PlainButton>
    )}
    <h2><Trans>Edit Subtitles</Trans></h2>
  </div>
);

export default SubtitleTitle;
